import React from 'react'

const MovedPage = () => {

    React.useEffect(() => {
        const timer = setTimeout(() => {
          window.location.href = "https://client.by.sppltd.ru";
        }, 5000);
    
        return () => clearTimeout(timer);
      }, []); 
    
    return (
        <div style={{
            textAlign: 'center',
            padding: '50px',
            maxWidth: '800px',
            margin: '0 auto'
        }}>
            <h1>Мы переехали!</h1>
            <p>
                Наш сервис теперь доступен по новому адресу: 
                <a href="client.by.sppltd.ru" style={{color: '#7A0202'}}> client.by.sppltd.ru</a>
            </p>
            <p>
                Вы будете автоматически перенаправлены через 5 секунд...
            </p>

        </div>
    )
}

export default MovedPage